import { Box, Button, InputLabel, MenuItem, Select, Stack, TextField, Typography } from "@mui/material";
import { DateTimePicker } from "@mui/x-date-pickers";
import { useEffect, useState } from "react";
import { useAuth } from "../../../provider/authProvider";
import { useSignalRContext } from "../../../SignalR/useSignalR";
import moment from "moment";

export const EditOrder=(props)=>{
    
    const data = props.data;
    const style = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: 400,
        bgcolor: 'background.paper',
        border: '2px solid #000',
        boxShadow: 24,
        p: 4,
      };
    //   console.log("PROPS => ",{data});
    //   const {
    //     id,
    //     clOrderId,
    //     time,
    //     expireTime,
    //     timeInForce,
    //     type,            
    //     symbolId,
    //     symbolName,
    //     targetPrice,
    //     volume,
    //     tradeSide,
    //     stopLoss,
    //     takeProfit
    // } = data;
    // console.log({data, /*type: data.type, volume: data.volume, price: data.targetPrice,*/ expiry: data.expireTime})
      const {token} = useAuth();
      const [clOrderId, setclOrderId] = useState(data.clOrderId);
      const [clOrderIdError, setClOrderIdError] = useState(false);
      const [symbol, setSymbol] = useState({name: data.symbolName, id: data.symbolId});
      const [symbolError, setSymbolError] = useState(false);
      const [volume, setVolume] = useState(data.volume);
      const [pendingPrice, setPendingPrice] = useState(data.targetPrice);
      const [pendingPriceError, setPendingPriceError] = useState("");
      const [volumeError, setVolumeError] = useState(false);
      const [orderType, setOrderType] = useState(data.type);
      const [orderTypeError, setOrderTypeError] = useState(false);
      const [tifType, setTIFType] = useState("Immediate or Cancel (IOC)");
      const [tifTypeError, setTIFTypeError] = useState(false);
      const [expiry, setExpiry] = useState((data.expireTime) ? moment(data.expireTime) : null );
      const [expiryError, setExpiryError] = useState();
  
  
      const { symbolsList, sendOrderAmmendRequest } =useSignalRContext();
      
     
    //   const handleSendOrder = () =>{
    //       console.log("Sending Order...");
    //   };
    //   const handleBuy = () =>{
    //       const ClOrderID = Date.now();
    //       console.log("order type ", orderType);
    //       const param= {
    //           Type: orderType,
    //           ClOrdId: ClOrderID,
    //           SymbolId: symbol.id,
    //           TradeSide: "Buy",
    //           Quantity: volume,
    //           TargetPrice: orderType === "Limit" || orderType === "Stop" ?//orderType === "2" || orderType === "3" ?
    //                           parseFloat( pendingPrice) : 0.00 ,
    //           Expiry: orderType === "Limit" || orderType === "Stop" ?
    //                       expiry :  null,
    //           PositionId: null,
    //           //Designation: ""
    //       }
    //       sendOrderRequest(token, param);
    //       console.log("Sending Order BUY...");
    //   };
    //   const handleSell = () =>{
    //       const ClOrderID = Date.now();
    //       const param= {
    //           Type: orderType,
    //           ClOrdId: ClOrderID,
    //           SymbolId: symbol.id,
    //           TradeSide: "Sell",
    //           Quantity: volume,
    //           TargetPrice: orderType === "Limit" || orderType === "Stop" ?//orderType === "2" || orderType === "3" ?
    //                           parseFloat( pendingPrice) : 0.00 ,
    //           Expiry: orderType === "Limit" || orderType === "Stop" ?
    //                       expiry :  null,
    //           PositionId: null,
    //           Designation: ""
    //       }
    //       sendOrderRequest(token, param);
    //       console.log("Sending Order SELL...");
    //   };
      const handleAmmend= ()=>{
        /**
         *  "ClOrdId": ""+order.ClOrdId,
            "OrderType" : order.Type,
            "OrderId" : order.OrderId,
            "OrderQty": parseFloat(order.Quantity),
            "TargetPrice": order.TargetPrice,
            "Expiry": order.Expiry       
         */
        const param= {
            ClOrdId: data.clOrderId,
            Type: orderType,
            OrderId: data.id,
            Quantity: volume,
            TargetPrice:  parseFloat( pendingPrice) ,
            Expiry: orderType === "Limit" || orderType === "Stop" ?
                        expiry :  null,
        }
        console.log("Ammend order param => ",{param});
        sendOrderAmmendRequest(token, param);
      };
      useEffect(()=>{
        const symbolDetail = symbolsList.find((i)=>i.name === data.symbol);
        if(symbolDetail) 
            setSymbol ( symbolDetail);
      },[data, data.symbol]);
    return(
        <Box
            sx={style}>
            <Typography variant="h6" component="h2">Ammend Order</Typography>
            <form onSubmit={handleAmmend}>
            <Stack 
                justifyContent="center"
                spacing={1}
                marginTop={"15px"}
                >
                <InputLabel id="Symbol">Symbol</InputLabel>
                <TextField
                    //label = "Symbol"
                    //onChange={e=>setclOrderId(e.target.value)}
                    required
                    variant="outlined"
                    color="primary"
                    type="symbol"
                    size="small"
                    value={symbol.name}
                    error={symbolError}
                    margin="normal"
                    disabled={true}
                />
                <InputLabel id="Direction">Direction</InputLabel>
                <TextField
                    //label = "Symbol"
                    //onChange={e=>setclOrderId(e.target.value)}
                    required
                    variant="outlined"
                    color="primary"
                    type="direction"
                    size="small"
                    value={data.tradeSide}
                    //error={symbolError}
                    margin="normal"
                    disabled={true}
                />
                <InputLabel id="Volume">Volume</InputLabel>
                <TextField                    
                    onChange={e=>setVolume(e.target.value)}
                    required
                    variant="outlined"
                    color="secondary"
                    size="small"
                    type="volume"                    
                    value={volume}
                    error={volumeError}
                    margin="normal"
                />
                <InputLabel id="TargetPrice">Target Price</InputLabel>
                <TextField                    
                    onChange={e=>setPendingPrice(e.target.value)}
                    required
                    variant="outlined"
                    color="secondary"
                    size="small"
                    type="volume"                    
                    value={pendingPrice}
                    error={pendingPriceError}
                    margin="normal"
                />
                <InputLabel id="oType">OrderType</InputLabel>
                <TextField                    
                    onChange={e=>setOrderType(e.target.value)}
                    required
                    variant="outlined"
                    color="secondary"
                    size="small"
                    type="orderType"                    
                    value={orderType}
                    error={orderTypeError}
                    margin="normal"
                    disabled={true}
                />
                <InputLabel id="expiry" >Expiry</InputLabel>
                <DateTimePicker
                    disablePast
                    //format="DD/MM/YYYY hh:mm:ss a"
                    //views={['day', 'month', 'year', 'hours', 'minutes', 'seconds']}
                   // defaultValue={dayjs.utc(data.expireTime) }
                    value={expiry}
                    onChange={(newDate)=> setExpiry((newDate))}
                />
                <Stack direction="row"
                 spacing={2}
                 justifyContent={"center"}
                 >

                    <Button
                        onClick={handleAmmend}
                        variant="contained"
                        color="warning"
                    >AMMEND ORDER</Button>
                </Stack>
             </Stack>   
           </form>
        </Box>
    );
}